import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon'; 
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { IconDetailComponent, IconDetailModel } from '../../../common/icon-detail/icon-detail.component';
import { Icons } from '../../../domain/enums/icons-enums';
import { UserGroup } from '../../../domain/models/user-group.model';
import { PaymentOfficeListDataSource } from './payment-office-list.datasource';
import { PaymentOffice } from '../../../domain/models/payment-office.model';
import { CustomDialogFactory } from '../../../domain/services/dialog/custom-dialog.factory';
import { PaymentOfficeServiceService } from '../../../domain/services/payment-office/payment-office.service.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DialogTypeEnum } from '../../../domain/enums/dialog-type.enum';
 
@Component({
  selector: 'app-payment-office-list',
  standalone: true,
 imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonToggleModule,
    FormsModule,
    MatPaginatorModule,
    RouterModule,
    MatTableModule,
    MatInputModule,
    MatSortModule,
    MatSelectModule,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    IconDetailComponent,
    FormsModule,
    ReactiveFormsModule, 
    MatCheckboxModule,  
],
  templateUrl: './payment-office-list.component.html',
  styleUrl: './payment-office-list.component.css'
})
export class PaymentOfficeListComponent  implements OnInit, AfterViewInit{
 constructor( private readonly service: PaymentOfficeServiceService, private readonly dialog: CustomDialogFactory) {
     }
  @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatTable) table!: MatTable<PaymentOffice>;
      icons = Icons 
    query = ""; 
    dataSource = new PaymentOfficeListDataSource([]);  
    displayedColumns = [ 'name', 'isActive','actions'];
    userModel: IconDetailModel | undefined;
    paymentOffices : PaymentOffice [] = [];
     ngOnInit(): void { 
           this.service.getCount().subscribe(value => {
        this.userModel = { icon: Icons.PersonPinIcon, label: 'Total Payment Offices', value: value.toString() , hideVerticalLine: true};
      });
  }
  ngAfterViewInit(): void { 
    this.service.getAll().subscribe(value => {
      this.paymentOffices = value; 
      
      this.rebuildDataSource(value);
    });
  }

  onSearch() {
    this.paginator.pageIndex = 0; //reset paginator on search
    if (this.query.length > 2) {
      const data = this.paymentOffices.filter(value =>
       value.name.toLowerCase().includes(this.query.toLowerCase())
      );
  
      this.rebuildDataSource(data);
    }else{
      const data = this.paymentOffices; 
      this.rebuildDataSource(data);
    }

  
  }
   rebuildDataSource(data: PaymentOffice[]) {
        this.dataSource = new PaymentOfficeListDataSource(data); 
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.table.dataSource = this.dataSource;
  }

    addNewPaymentOffice(){
    let data: PaymentOffice = {
      id: 0,
      name: '',
      active: false
    };
    this.dialog.openDialog(DialogTypeEnum.NEW_PAYMENT_OFFICE, {}, (data: PaymentOffice) => {
      this.service.create(data).subscribe(value => {
        this.service.getAll().subscribe(value => {
          this.paymentOffices = value; 
          
          this.rebuildDataSource(value);
        });
      });
       });
  }

  editPaymentOffice(data: PaymentOffice){
  this.dialog.openDialog(DialogTypeEnum.NEW_PAYMENT_OFFICE, data, (data: PaymentOffice) => {
      this.service.update(data).subscribe(value => {
        this.service.getAll().subscribe(value => {
          this.paymentOffices = value;
          this.rebuildDataSource(value);
        });
      });
       });
  }

  toggleActive(office: PaymentOffice, checked: boolean){
    const updated: PaymentOffice = { ...office, active: checked };
    this.service.update(updated).subscribe(value => {
      office.active = checked;
    }, () => {
      // revert UI on failure
      office.active = !checked;
    });
  }

  deletePaymentOffice(office: PaymentOffice){
    if (!office.id) return;
    this.dialog.openDialog(DialogTypeEnum.CONFIRMATION, {
      title: 'Delete Payment Office',
      message: `Are you sure you want to delete "${office.name}"? This action cannot be undone.`
    }, (confirmed: boolean) => {
      if (confirmed) {
        this.service.delete(office.id!).subscribe(() => {
          this.service.getAll().subscribe(value => {
            this.paymentOffices = value;
            this.rebuildDataSource(value);
          });
        });
      }
    });
  }
}
